import styled from 'styled-components'

export const StyledHeader = styled.span`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
`
